const getLocalStorage = () => JSON.parse(localStorage.getItem("user"));

export const userDetails = () => JSON.parse(localStorage.getItem("user"));
export const userName = () => JSON.parse(localStorage.getItem("user"))?.fullName;
export const userType = () => JSON.parse(localStorage.getItem("user"))?.userType;
export const Token = () => JSON.parse(localStorage.getItem("user"))?.token;
export const userId = () => JSON.parse(localStorage.getItem("user"))?.id;
